// src/AnalogsContext.js
import React, { createContext, useContext, useState } from "react";

const AnalogsContext = createContext();

export function AnalogsProvider({ children }) {
  const [analogs, setAnalogs] = useState({});

  return (
    <AnalogsContext.Provider value={{ analogs, setAnalogs }}>
      {children}
    </AnalogsContext.Provider>
  );
}

export const useAnalogs = () => useContext(AnalogsContext);